import React, { memo } from 'react'
import { StyleSheet, Text, View } from 'react-native'

import { SuccessFailurePrompt } from '../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import { ECommerceRedirectionLabel } from './ECommerceRedirectionLabel'

interface PayWithBluetapeCreditFlow_SUCCESSProps {
  onSuccess: () => void
}

export const PayWithBluetapeCreditFlow_SUCCESS: React.FC<PayWithBluetapeCreditFlow_SUCCESSProps> =
  memo(({ onSuccess }) => {
    const { t } = useTranslation(['errors', 'global'])

    return (
      <SuccessFailurePrompt
        visible={true}
        icon={<PromptSuccessIcon />}
        title={t(
          'global:CreditApplication.submit-success-messages.with-invoice-previously-approved.title',
        )}
        message={
          <View>
            <Text style={styles.text} testID={'pay-with-btc-success-message'}>
              {t(
                'global:CreditApplication.submit-success-messages.with-invoice-previously-approved.message',
              )}
            </Text>
            <ECommerceRedirectionLabel
              onRedirect={onSuccess}
              wrapperStyle={styles.redirectionLabelWrapper}
            />
          </View>
        }
        exitable={false}
        buttonData={{
          title: 'Ok, got it',
          contentStyle: { width: '100%' },
          style: { width: '90%' },
          onPress: onSuccess,
        }}
        textContentBottomMargin={20}
        onDismiss={onSuccess}
      />
    )
  })

const styles = StyleSheet.create({
  text: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: 21,
    color: '#001929',
  },
  redirectionLabelWrapper: {
    borderTopColor: '#DEE5EB',
    borderTopWidth: 1,
    paddingVertical: 10,
    marginTop: 10,
  },
})
